import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lot-documents" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "document-body" }
const _hoisted_4 = { class: "document-content" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = {
  key: 1,
  class: "card card-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Documents", -1)),
    ($setup.props.documents?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.documents, (document, index) => {
            return (_openBlock(), _createBlock($setup["DocumentItemWithSlot"], {
              class: "documents-item",
              key: index,
              link: document.link,
              name: document.fileName,
              classes: { preview: 'document-preview', container: 'document-item-container' }
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString($setup.getDocumentName(document.fileName)), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString($setup.formatDateMonthDayYear(document.modifiedDate)), 1)
                ])
              ]),
              _: 2
            }, 1032, ["link", "name"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "lot-no-detail-items" }, "There are no uploaded documents for this lot yet", -1)
        ]))]))
  ]))
}